import React from 'react';
import PropTypes from 'prop-types';

import { MUIModal } from 'Components/Base';

import ClearFileExceedContent from './ClearFileExceedContent';

const ClearFileExceedModal = ({ onContinue, muiProps, ...props }) => {
  const { isActive, toggleComponent, onOpen, onClose } = muiProps;
  return (
    <MUIModal
      isOpen={isActive}
      toggleComponent={toggleComponent}
      onOpenModal={onOpen}
      onCloseModal={onClose}
      modalStyle={{ padding: '36px', borderRadius: '16px', maxWidth: '343px', height: '350px' }}
      innerProps={{ height: '100%' }}
      closeIcon={false}
      disableBackdropClick
      {...props}
    >
      <ClearFileExceedContent onContinue={onContinue} />
    </MUIModal>
  );
};

ClearFileExceedModal.propTypes = {
  muiProps: PropTypes.shape({
    toggleComponent: PropTypes.element,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isActive: PropTypes.bool,
  }),
  onContinue: PropTypes.func,
};

export default ClearFileExceedModal;
